<template>
  <div>
    <v-dialog
      v-model="AgoraCallDialog"
      width="500"
      persistent
    >
      <v-card style="height: 350px !important;">
        <v-card-text>
          <v-layout column wrap justify-center align-center style="height: 230px !important;">
            <v-avatar
              :size="100"
            >
            <img :src="infor_call.path_pic" class="img-w-h" v-if="infor_call.path_pic">
            <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
            </v-avatar>
            <h2 class="text-overflow mt-3">{{infor_call.nickname}}</h2>
          </v-layout>
          <v-layout row wrap justify-center align-center>
            <v-btn class="border-radius" color="primary" @click="accept_call()">รับสาย</v-btn>
            <v-btn class="border-radius" dark color="red" @click="closedialog()">ปฏิเสธ</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <audio src="/static/sound/sound_1.mp3" id="soundRingtone" loop></audio>
    <!-- <audio src="/static/sound/sound_3.wav" id="soundRingtone2" loop></audio> -->
    <!-- <audio id="soundRingtone" loop>
      <source src="/static/sound/sound_1.mp3" type="audio/mpeg">
    </audio> -->
    <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
  </div>
</template>
<script>
import { Encode } from '@/services'
import CheckBrowserDialog from '@/components/chat/dialog/CheckBrowserDialog'
export default {
  props: {
    AgoraCallDialog: Boolean,
    infor_call: {},
    tokenuser: String,
    AgoraOption: String
  },
  components: {
    CheckBrowserDialog
  },
  data () {
    return {
      checkBrowserInfor: {},
      checkBrowserDialog: false,
    }
  },
  watch: {
    AgoraCallDialog () {
      if (this.AgoraCallDialog) {
        console.log(this.infor_call)
        var soundRingtone = document.getElementById('soundRingtone')
        soundRingtone.currentTime = 0
        soundRingtone.play()
        // soundRingtone.loop = true
      }
    }
  },
  methods: {
    closeCheckBrowser (value) {
      this.checkBrowserDialog = value
      this.checkBrowserInfor = {}
    },
    closedialog () {
      this.$emit('decline_call', this.infor_call)
      this.$emit('closeAgoraDialog', false)
    },
    accept_call () {
      var soundRingtone = document.getElementById('soundRingtone')
      soundRingtone.pause()
      soundRingtone.currentTime = 0

      this.axios.post(process.env.APIalpine + `/api/v1/join-agora`, {
        tokenroom: this.infor_call.tokenroom,
        tokenmessage: this.infor_call.tokenmessage,
        tokenuser: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        this.$emit('closeAgoraDialog', false)
        this.checkBrowser(url)
      }).catch(error => {
        console.log(error)
      })
    },
    checkBrowser (url) {
      // console.log(url)
      // Get the user-agent string
      let userAgentString = navigator.userAgent;
      // Detect Chrome
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      let safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      let operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
       if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
         this.checkBrowserInfor = {
           url: url,
           payload: ''
         }
        this.checkBrowserDialog = true
       } else if (safariAgent === true && chromeAgent === true) {
         window.open(url, '_blank')
       } else if (safariAgent === true) {
         this.checkBrowserInfor = {
           url: url,
           payload: ''
         }
         this.checkBrowserDialog = true
      } else {
        window.open(url, '_blank')
      }
    },
  }
}
</script>
<style media="screen" scroped>
.img-w-h {
  object-fit: cover;
  object-position: 50% 40%;
  height: 150px;
  width: 100%;
}
.text-overflow {
  max-width: 400px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}
.border-radius {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/agora_call/ans_call.vue